import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import client from './graphql/client'
import { ApolloProvider } from '@apollo/client'
import { AuthProvider } from './AuthContext'

ReactDOM.render(
  // <React.StrictMode> Commenter car provoque erreur findDOMNode is deprecated in StrictMod (je pense liée au onClick sur les TableCell du UserTable)
  <ApolloProvider client={client}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </ApolloProvider>,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
